import { useLanguage } from '../../shell/language-context';
import { OfferArt } from '../../shell/offer-art';
import type { OfferView } from './offer-view';

// The offer card (design "Offer Card Options", option 4): a 4:5 portrait poster that
// shows the merchant's whole creative — contained, never cropped — over a blurred,
// dimmed copy of itself, so a portrait, square or banner upload all fill the same
// frame with no empty bars. Captions sit on a solid bar below; no text ever overlays
// the artwork. The card is a button: a tap opens the offer popup, which is where the
// details, the price and every action live. A paid placement is always labelled
// (AP-D10); `tag` is the rail's own marker ("New" on the just-added rail).
export function OfferPosterCard({ view: v, onOpen, tag, className }: { view: OfferView; onOpen: (view: OfferView) => void; tag?: string; className?: string }) {
  const { t } = useLanguage();
  const label = `${v.bizName} — ${v.title}`;
  return (
    <article className={className ? `ofp ${className}` : 'ofp'}>
      <button type="button" className="ofp__btn" onClick={() => onOpen(v)} aria-label={t('dc52.popup.open', { offer: label })}>
        <span className="ofp__frame">
          {v.image ? (
            <>
              <span className="ofp__blur" style={{ backgroundImage: `url('${v.image.poster}')` }} aria-hidden="true" />
              <img className="ofp__img" src={v.image.poster} alt="" loading="lazy" decoding="async" />
            </>
          ) : (
            <OfferArt />
          )}
          {v.sponsored ? <span className="ofp__sp">{t('dc52.sponsored')}</span> : null}
          {tag ? <span className="ofp__tag">{tag}</span> : null}
        </span>
        <span className="ofp__cap">
          <span className="ofp__chips">
            <span className="ofp__chip ofp__chip--deal">{v.off}</span>
            <span className={v.ends.urgent ? 'ofp__chip ofp__chip--ends is-urgent' : 'ofp__chip ofp__chip--ends'}>⏳ {v.ends.label}</span>
          </span>
          <span className="ofp__biz">{v.bizName}</span>
          <span className="ofp__title">{v.title}</span>
          <span className="ofp__meta">{[v.category, v.area].filter(Boolean).join(' · ')}</span>
        </span>
      </button>
    </article>
  );
}
